import { useParams } from 'react-router-dom';
import { ParentOrgGeneralAttributesForm } from './ParentOrgGeneralAttributesForm';
import AddEdit from '../../../../CommonPage/AddEdit';
import { fetchIdsFromSelectedDropdownValues } from '../../../../../../utils/validators/HelperFunctions';
import strings from '../../../../../../common/Translation/Translate';
import { URLS } from '../../../../../../utils/constants/urls';
import { routes } from '../../../../../../utils/constants/routes';

type GeneralTabProps = {
  pageResponse: any;
  dropdowns: any;
  languages: any;
};

const ParentOrgGeneralAttributes = ({ pageResponse, dropdowns, languages }: GeneralTabProps) => {
  const { id } = useParams() as any;

  const buildParentOrganizationFormModel = () => {
    const baseFormModel = [...ParentOrgGeneralAttributesForm(strings, dropdowns)] as any;

    // Inject language-specific name fields after the first item (index 0)
    if (languages !== undefined) {
      languages?.forEach((language: any) => {
        const translatedNameField = { ...ParentOrgGeneralAttributesForm(strings, dropdowns)[0] };
        translatedNameField.field = `name_${language.value}`;
        translatedNameField.label = `${translatedNameField.label} (${language.text})`;

        baseFormModel.splice(0, 0, translatedNameField);
      });
    }

    // Remove the default 'name' field (since we're replacing it with multilingual variants)
    return baseFormModel.filter((field: any) => field.field !== 'name');
  };

  const pageConfig = {
    title: strings.parentOrg_title_update,
    successMessage: strings.common_update_message,
    addEditApiUrl: URLS.get_edit_parentOrganizationById(id),
    formModel: buildParentOrganizationFormModel(),
    navigateToPage: routes.parentOrganization,
    isCustomResponse: true,
    hideClose: true,
  };

  const buildRequestPayload = (formValues: any) => {
    const localizedAttributes =
      languages?.map((lang: { text: string; value: string }) => ({
        language: lang.value,
        name: formValues[`name_${lang.value}`],
      })) ?? [];

    return {
      eventTypes: fetchIdsFromSelectedDropdownValues(formValues.eventTypes),
      show24HourClock: formValues.show24HourClock ?? false,
      venueTypes: fetchIdsFromSelectedDropdownValues(formValues.venueTypes),
      layouts: fetchIdsFromSelectedDropdownValues(formValues.layouts),
      locations: fetchIdsFromSelectedDropdownValues(formValues.locations),
      localizedAttributes,
    };
  };

  return (
    <AddEdit pageConfig={pageConfig} pageResponse={pageResponse} handleCustomResponse={buildRequestPayload as any} />
  );
};

export default ParentOrgGeneralAttributes;
